import { useCallback, useEffect, useState } from "react";

type KeyboardKey = "Alt" | "Control" | "Shift";

export const usePressedKeyboardKey: () => KeyboardKey | null = () => {
    const [pressedKey, setPressedKey] = useState<KeyboardKey | null>(null);

    const keyDownHandler = useCallback(({ key }: KeyboardEvent) => {
        switch (key) {
            case "Alt":
                setPressedKey("Alt");
                break;
            case "Control":
                setPressedKey("Control");
                break;
            case "Shift":
                setPressedKey("Shift");
                break;
        }
    }, []);

    const keyUpHandler = useCallback(() => {
        setPressedKey(null);
    }, []);

    useEffect(() => {
        window.addEventListener("keydown", keyDownHandler);
        window.addEventListener("keyup", keyUpHandler);
        return () => {
            window.removeEventListener("keydown", keyDownHandler);
            window.removeEventListener("keyup", keyUpHandler);
        };
    }, [keyDownHandler, keyUpHandler]);

    return pressedKey;
};
